import React from 'react';
import PropTypes from 'prop-types';

const IconDropRight = ({ width = 16, height = 16, color = '#1F1F1F' }) => {
    return (
        <svg width={width} height={height} viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path fillRule='evenodd' clipRule='evenodd' d='M10.7 8L6.7 12L6 11.3L9.29 8L6 4.7L6.7 4L10.7 8Z' fill={color} />
        </svg>
    );
};

IconDropRight.propTypes = {
    color: PropTypes.string,
    height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default React.memo(IconDropRight);
